export enum EComplaintStatus {
  PENDING_APPROVAL = 'PENDING',
  CLOSED = 'CLOSED',
  RESOLVED = 'RESOLVED',
  RE_OPENED = 'RE_OPENED',
  ONGOING = 'ONGOING',
  REJECTED = 'REJECTED',
}
